import React from 'react'

interface ZhIconProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

export const ZhIcon = (props: ZhIconProps) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <g clipPath="url(#clip0_12114_94736)">
        <path d="M1 1.19922H21V21.1992H1V1.19922Z" fill="#EE1C25" />
        <path
          d="M5.58444 3.97266L7.46179 9.75034L2.54688 6.17961H8.62201L3.7071 9.75034L5.58444 3.97266Z"
          fill="#FFFF00"
        />
        <path
          d="M14.0425 8.9316L12.448 10.1799L13.0043 8.23274L13.6987 10.135L12.0188 9.00419L14.0425 8.9316Z"
          fill="#FFFF00"
        />
        <path
          d="M11.2833 10.4295L11.1894 12.4523L10.0764 10.7606L11.9712 11.4751L10.0183 12.0108L11.2833 10.4295Z"
          fill="#FFFF00"
        />
        <path
          d="M13.8066 5.36152L12.86 7.15166L12.5735 5.14699L13.9836 6.60049L11.9885 6.25333L13.8066 5.36152Z"
          fill="#FFFF00"
        />
        <path
          d="M11.3302 2.99387L11.1525 5.01106L10.1106 3.27465L11.9741 4.06707L10.0007 4.52131L11.3302 2.99387Z"
          fill="#FFFF00"
        />
      </g>
      <path
        d="M11 0.699219C16.799 0.699219 21.5 5.40023 21.5 11.1992C21.5 16.9982 16.799 21.6992 11 21.6992C5.20101 21.6992 0.5 16.9982 0.5 11.1992C0.5 5.40023 5.20101 0.699219 11 0.699219Z"
        stroke="#D6D8DC"
      />
      <defs>
        <clipPath id="clip0_12114_94736">
          <path
            d="M1 11.1992C1 5.67637 5.47715 1.19922 11 1.19922C16.5228 1.19922 21 5.67637 21 11.1992C21 16.7221 16.5228 21.1992 11 21.1992C5.47715 21.1992 1 16.7221 1 11.1992Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
